<template>
  <div class="musicDetail">
    <router-link to="/music" class="returnButton" id="return"><span>×</span></router-link>
    <router-link :to="previousLink" class="switchButton" id="previous"><span>&lt;</span></router-link>
    <div class="mainContent">
      <div class="half-split musicArea">
        <canvas id="wave" ref="waveCanvas" :width="canvasSize" :height="canvasSize"></canvas>
        <span class="material-icons play-button" ref="play" v-on:click="playOrStop">play_arrow</span>

        <!--<a href="#" ref="play" id="play" v-on:click="playOrStop"></a>-->
      </div>
      <div class="half-split information">
        <h3 class="title" v-html="title"></h3>
        <h4 class="creator">{{creator}}</h4>
        <p class="comment" v-html="comment"></p>
        <TwitterButton v-bind:title="title" :key="title"></TwitterButton>
      </div>
    </div>
    <router-link :to="nextLink" class="switchButton" id="next"><span>&gt;</span></router-link>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
window.requestAnimationFrame = (() => {
    return (
        window.requestAnimationFrame ||
        window.webkitRequestAnimationFrame ||
        window.mozRequestAnimationFrame ||
        function(callback, element){

            window.setTimeout(callback, 1000/60);
        }
    );
})();

window.AudioContext = (() => {
    return (
        window.webkitAudioContext || window.AudioContext || window.mozAudioContext
    );
})();
/* eslint-enable no-unused-vars */
import TwitterButton from '../common/TwitterButton';


export default {
  name: 'MusicDetailControll',
  components: {
    TwitterButton
  },
  props: ['musicData','previousID','nextID'],
  data(){
    return{
      isPlaying: false,
      audioBufferSource: null,
      audioContext: null,
      analyser: null,
      bufferLength : null,
      mData: null,
      buffer: null,
      timerID: null,
      context: null,
      canvas: null,
      audioData: null
    }
  },
  computed: {
    title: function(){
      if(this.musicData)
        return this.musicData.title;
      else
        return null;
    },
    previousLink: function(){
      if(this.previousID)
        return '/music/' + this.previousID;
      else
        return '#';
    },
    nextLink: function(){
      if(this.nextID)
        return '/music/' + this.nextID;
      else
        return '#';
    },
    imageURL: function(){
      if(this.musicData)
        return this.musicData.imageURL;
      else
        return "#";
    },
    creator: function(){
      if(this.musicData)
        return this.musicData.creator;
      else
        return null;
    },
    comment: function(){
      if(this.musicData)
        return this.musicData.comment.replace(/\n/g,'<br>');
      else
        return null;
    },
    canvasSize: function(){
      if(window.innerWidth < 1280)
        return Math.floor(window.innerWidth * 0.9);
      else
        return Math.floor(window.innerWidth * 0.3);
    }
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    playOrStop : function(event){
      if(this.isPlaying){
        this.audioBufferSource.stop();
        cancelAnimationFrame(this.timerID);
        this.$refs.play.textContent = "play_arrow";
        this.isPlaying = false;
      }
      else{
        if(this.audioContext == undefined){
          //変数初期化
          this.audioContext = new AudioContext();
          this.analyser = this.audioContext.createAnalyser();
          this.bufferLength = this.analyser.frequencyBinCount;
          this.mData = new Uint8Array(this.bufferLength);
          this.canvas = this.$refs.waveCanvas;
          this.context = this.canvas.getContext('2d');
          this.timerID = requestAnimationFrame(this.drawWave);
        }
        let xhr = new XMLHttpRequest();
        xhr.open('GET',this.musicData.musicURL,true);
        xhr.responseType = 'arraybuffer';
        // eslint-disable-next-line no-unused-vars
        xhr.onload = (()=>{
          this.audioContext.decodeAudioData(xhr.response).then((decodedData) => {
          this.buffer = decodedData;
          this.audioBufferSource = this.audioContext.createBufferSource();
          this.audioBufferSource.buffer = this.buffer;
          this.audioBufferSource.loop = false;
          this.audioBufferSource.connect(this.analyser);
          this.audioBufferSource.connect(this.audioContext.destination);
          this.audioBufferSource.start(0);
          this.$refs.play.textContent = "pause";
          this.isPlaying = true;
        });
      });
      xhr.send();
      }
    },
    drawWave: function(){
      this.context.fillStyle = "rgba(34, 34, 34, 1.0)";
      this.context.fillRect(0,0,this.canvas.width,this.canvas.height);
      this.context.strokeStyle = "rgba(255,255,255,0.8)";
      this.analyser.getByteFrequencyData(this.mData);
      this.context.clearRect(0,0,this.context.width,this.context.height);
      let threshold = 0;
      this.context.save();
      this.context.globalCompositeOperation = "source-over";

      this.context.scale(0.5,0.5);
      this.context.translate(this.canvas.width,this.canvas.height);
      this.context.fillStyle = "#fff";

      let bass = Math.floor(this.mData[1]);
      let radius = 0.2 * this.canvas.width <= 200 ? -(bass * 0.25 + 0.2 * this.canvas.width): - (bass * 0.25 + 200);
      radius;
      bar_length_factor;
      let bar_length_factor = 0.75;
      
      for(let i = 0;i < 256; i++){
        let value = this.mData[i];
        if(value >= threshold){
          this.context.fillRect(0,radius,this.canvas.width <= 450?2:3,-value / bar_length_factor);
          this.context.rotate(((180 / 128) * Math.PI) / 180);
        }
      }
      this.context.restore();
      requestAnimationFrame(this.drawWave);
    },
    stopMusic(){
      if(this.isPlaying)
        this.playOrStop();
    }
  },
  watch: {
    musicData: function(){
      this.stopMusic();
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.musicDetail{
  height: 100%;
  width: 100%;
  background-color: rgba(0,0,0,0.8);
  position: absolute;
  display: block;
  margin: 0;
  padding: 0;
  top: 0;
  left:0;
}

.switchButton{
  display: none;
  position: relative;
  width: 80px;
  height: 100%;
  margin:0;
  padding:0;
  background-color: rgba(0,0,0,0.7);
  
  vertical-align: middle;
  line-height: 100%;
}

.switchButton > span{
   display: inline-block;
   position: absolute;
   top: 50%;
   left: 50%;
   margin: 0;
   margin-right: -50%;
   transform: translate(-50%,-50%);
   color: white;
   font-size: 2.5em;
}

.returnButton{
  display: block;
  position: relative;
  /*top: 80px;*/
  right:0;
  width: 50px;
  height: 50px;
  margin:0;
  margin-left: calc(100% - 50px);
  padding:0;
  color: white;
  vertical-align: middle;
  font-size:2.5em;
  z-index: 1000;
}

.returnButton > span{
   display: inline-block;
   position: absolute;
   top: 50%;
   left: 50%;
   margin: 0;
   margin-right: -50%;
   transform: translate(-50%,-50%);
   color: white;
   font-size:40px;
}

.mainContent{
  height: calc(100%  - 50px);
  display: block;
  overflow-y: auto;
}

/*.half-split{
  margin: 0;
  padding: 0;
  width: 50%;
  height: 100%;
  display: inline-block;
}*/

.musicArea{
  height: 100vw;
  width: 100vw;
  padding: auto;
  display: inline-block;
  align-items: center;
  justify-content: center;
  position: relative;
}

#play{
  width: 75px;
  height: 75px;
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  margin: 0;
  transform: translate(-50%,-50%);
  background-color: rgba(0,0,0,0);
  z-index: 500;
}

.play-button{
  display:block;
  position: absolute;
  top: 50%;
  left: 50%;
  margin: 0;
  transform: translate(-50%,-50%);
  font-size: 75px;
  color: white;
  z-index: 10;
}

/*.imageArea img{
  display: inline-block;
  max-width: 95%;
  max-height: 95%;
}*/

.information{
  text-align:center;
  padding-bottom: 65px;
}

.information h3{
  font-size: 1.5em;
  color:white;
  margin: 15px;
}

.information p{
  display: inline-block;
  width: 90%;
  /*max-height: 400px;*/
  overflow-y: auto;
  font-size: 1.0em;
  color:white;
  text-align: left;
}

.information h4{
  font-size: 1.25em;
  color:white;
}

canvas#wave{
  position: absolute;
  top: 50%;
  left: 50%;
  margin: 0;
  margin-right: -50%;
  transform: translate(-50%,-50%);
  background-color: rgba(0,0,0,0.8);
}

@media screen and (min-width: 600px){
  .returnButton{
  width: 70px;
  height: 70px;
  margin-left: calc(100% - 70px);
}
.mainContent{
  height: calc(100%  - 70px);
}
.information h3{
  font-size: 2.5em;
}

.information p{
  font-size: 1.5em;
}

.information h4{
  font-size: 2.0em;
}
}

@media screen and (min-width: 1280px){
.musicDetail{
  height: calc(100vh  - 80px);
  width: 100%;
  background-color: rgba(0,0,0,0.8);
  position: absolute;
  display: flex;
  top: 0;
  left:0;
}

.switchButton{
  display: inline-block;
  position: relative;
  width: 80px;
  height: 100%;
  margin:0;
  padding:0;
  background-color: rgba(0,0,0,0.7);
  
  vertical-align: middle;
  line-height: 100%;
}

.switchButton > span{
   display: inline-block;
   position: absolute;
   top: 50%;
   left: 50%;
   margin: 0;
   margin-right: -50%;
   transform: translate(-50%,-50%);
   color: white;
   font-size:40px;
}

.returnButton{
  display: block;
  position: absolute;
  /*top: 80px;*/
  right:0;
  width: 80px;
  height: 80px;
  margin:0;
  padding:0;
  color: white;
  vertical-align: middle;
  font-size:25px;
  z-index: 1000;
}

.returnButton > span{
   display: inline-block;
   position: absolute;
   top: 50%;
   left: 50%;
   margin: 0;
   margin-right: -50%;
   transform: translate(-50%,-50%);
   color: white;
   font-size:40px;
}

.mainContent{
  height: calc(100vh  - 80px);
  flex:1;
  display: inline-flex;
}

.half-split{
  margin: 0;
  padding: 0;
  width: 50%;
  height: 100%;
  display: inline-block;
}

.musicArea{
  padding: auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

#play{
  width: 100px;
  height: 100px;
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  margin: 0;
  transform: translate(-50%,-50%);
  background-color: rgba(0,0,0,0);
  z-index: 500;
}

.play-button{
  display:block;
  position: absolute;
  top: 50%;
  left: 50%;
  margin: 0;
  transform: translate(-50%,-50%);
  font-size: 75px;
  color: white;
  z-index: 10;
}

/*.imageArea img{
  display: inline-block;
  max-width: 95%;
  max-height: 95%;
}*/

.information{
  text-align:center;

}

.information h3{
  font-size: 65px;
  color:white;
  margin: 15px;
}

.information p{
  display: inline-block;
  width: 90%;
  max-height: 400px;
  overflow-y: auto;
  font-size: 22px;
  color:white;
  text-align: left;
}

.information h4{
  font-size: 30px;
  color:white;
}

canvas#wave{
  position: absolute;
  top: 50%;
  left: 50%;
  margin: 0;
  margin-right: -50%;
  transform: translate(-50%,-50%);
  background-color: rgba(0,0,0,0.8);
}
}
</style>

